import { QualityLevel } from "../organisation/Organisation"
import { BidModel, buildBidModel } from "./BidModel"

export class OrgBidModel {
    organisationId?: number
    bids: BidModel[]
    grading: QualityLevel[]

    constructor(b: any) {
        this.organisationId = b.organisation_id
        this.bids = b.bids.map(b => buildBidModel(b))
        this.grading = b.grading
    }

    getTodayPrice(marketDay: string): BidModel|undefined {
        return this.bids.find(b => b.market_day === marketDay)
    }
}

export function buildOrgBid(p: any): OrgBidModel {
    return new OrgBidModel(p)
}